<template><div><h1>VUX V2.3.2 released</h1>
<h2><a href="/en/components/checker.html">Checker</a></h2>
<ul><li>[enhance] Support unselecting current item when clicking again in radio mode #1468</li>
</ul>
<h2><a href="/en/components/group.html">Group</a></h2>
<ul><li>[feature] prop:gutter could be a number</li>
</ul>
<h2><a href="/en/components/x-number.html">XNumber</a></h2>
<ul><li>[fix] fix undefined-min detecting logic. #1459</li>
</ul>
<h2><a href="/en/components/date.html">Date</a></h2>
<ul><li>[enhance] return empty string when no date is specified</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.3.2 released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.3.2-101.vue?7c5ab9b2